import { useLayoutEffect } from "react"
import { useLocation } from "react-router-dom"

/**
 * Scrolls window to top when the route pathname changes.
 * Must be rendered inside a Router so useLocation works.
 */
export function ScrollToTop() {
  const { pathname } = useLocation()

  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}
